(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

// sticky header
let lastScrollTop = 0;
let isHeaderFixed = false;

$(document).ready(function () {
    const $header = $('.header-wrapper');
    const $navFullWidth = $('.header-wrapper');
    const $mobileHeader = $('.mobile-width');
    let headerHeight = $header.height();
    let navmenuHeightDesktop = $('.header-wrapper').height();
    let navfullwidthHeightDesktop = headerHeight + navmenuHeightDesktop;
    let navHeightMobile = $header.height();

    function adjustFixedHeader() {
        let currentScrollTop = $(window).scrollTop();

        if (window.matchMedia('(min-width: 992px)').matches) {
            $mobileHeader.css('top', '');
            if (currentScrollTop > lastScrollTop) {
                // Scrolling down
                if (isHeaderFixed) {
                    $navFullWidth.stop().animate({ top: '-100%' }, 300, function () {
                        $navFullWidth.removeClass('fixed-header');
                    });
                    isHeaderFixed = false;
                }
            } else if (currentScrollTop < lastScrollTop && currentScrollTop > navfullwidthHeightDesktop) {
                // Scrolling up
                if (!isHeaderFixed) {
                    $navFullWidth.addClass('fixed-header').stop().animate({ top: '0' }, 300);
                    isHeaderFixed = true;
                }
            }

            if (currentScrollTop <= navfullwidthHeightDesktop && isHeaderFixed) {
                $navFullWidth.removeClass('fixed-header').stop().animate({ top: '0' }, 300);
                isHeaderFixed = false;
            }
        }

        if (window.matchMedia('(max-width: 991px)').matches) {
            $navFullWidth.css('top', '');
            if (currentScrollTop > lastScrollTop) {
                if (isHeaderFixed) {
                    $mobileHeader.stop().animate({ top: '-100%' }, 300, function () {
                        $mobileHeader.removeClass('fixed-header');
                    });
                    isHeaderFixed = false;
                }
            } else if (currentScrollTop < lastScrollTop && currentScrollTop > navHeightMobile) {
                if (!isHeaderFixed) {
                    $mobileHeader.addClass('fixed-header').stop().animate({ top: '0' }, 300);
                    isHeaderFixed = true;
                }
            }

            if (currentScrollTop <= navHeightMobile && isHeaderFixed) {
                $mobileHeader.removeClass('fixed-header').stop().animate({ top: '0' }, 300);
                isHeaderFixed = false;
            }
        }

        lastScrollTop = currentScrollTop;
    }

    let ticking = false;
    $(window).on('scroll', function () {
        if (!ticking) {
            requestAnimationFrame(() => {
                adjustFixedHeader();
                ticking = false;
            });
            ticking = true;
        }
    });
});


  } catch(e) { console.error(e); }
})();
})();
